import React, { Component } from "react";
import CreditLinesHeader from "./creditLinesHeader.js";
import CreditLineItem from "./CreditLineItem.js";
import UpdateModal from "./UpdateModal.js";
import IngestionBox from "./CreditLinesIngestionBox.js";
import "./../../../assests/styles/CreditLines.css";
import CreditLineApiHandler from "../CreditLineApiHandler.js";
import Dialog from "@material-ui/core/Dialog";
import CircularProgress from "@material-ui/core/CircularProgress";
import qs from "qs";

export default class CreditLine extends Component {
	constructor(props) {
		super(props);
		this.state = {
			// filter - states - starts
			bzId: null,
			creditLineStatus: null,
			productName: null,
			fromDpd: null,
			toDpd: null,
			equalToDpd: null,
			// filter - states - ends
			creditLineStatusSet: null,
			creditProducts: null,
			creditLines: null,
			pageNumber: 1,
			loading: false,
			showCircularLoading: false,
			openModal: false,
			openModalConfirmation: false,
			dataFromMerge: null,
			dataToMerge: null,
			selectedDataToMerge: null,
			loaderForMerging: null,
			destinationProductName: null,
			// update modal - states - starts
			openModalForStatusChange: false,
			showErrorModal: null,
			error: null,
			renderModalForUpdate: null,
			creditLineIdForupdate: null,
			creditLineStatusForUpdate: null
			// update modal - states - ends
		};
		this.limit = 50;
		this.offset = 0;
		this.handleSearch = this.handleSearch.bind(this);
		this.calculatePageNumber = this.calculatePageNumber.bind(this);
		this.showCreditLines = this.showCreditLines.bind(this);
		this.handleSearchForDestinationProductName = this.handleSearchForDestinationProductName.bind(this);
		this.handleClickOpen = this.handleClickOpen.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.destinationProductNamePicker = this.destinationProductNamePicker.bind(this);
		this.handleMoveToModal = this.handleMoveToModal.bind(this);
		this.showAvailableDestinationDestinationProducts = this.showAvailableDestinationDestinationProducts.bind(this);
		this.handleMove = this.handleMove.bind(this);
		this.handleMoveClick = this.handleMoveClick.bind(this);
		this.handleCloseConfirmation = this.handleCloseConfirmation.bind(this);
		this.handleMoveNowClick = this.handleMoveNowClick.bind(this);
		this.showModalContent = this.showModalContent.bind(this);
	}

	componentDidMount() {
		//this.handleSearch(null, null, null, null, null, null, null, 0);
		var lines = document.getElementById("creditLines");
		if (lines) {
			var filterHeight = document.getElementById("topFilter").offsetHeight;
			var headerHeight = document.getElementById("header").offsetHeight;
			lines.style.height = window.innerHeight - (filterHeight + headerHeight) + "px";
		}
		var product = qs.parse(this.props.location.search).productName;
		var businsessId = JSON.parse(localStorage.getItem("searched_bzid")) ? JSON.parse(localStorage.getItem("searched_bzid")) : qs.parse(this.props.location.search).bzid;

		if (businsessId) {
			this.setState({
				bzId:businsessId
			});
			document.getElementById("credit_line_input").value = businsessId;
			this.handleSearch(null, product, null, null, null, businsessId,0);
			this.fetchConfig(businsessId);
		}
	}

	showErrorMessageModal = () => {
		return (
			<div>
				<Dialog open={this.state.showErrorModal} aria-labelledby="responsive-dialog-title" maxWidth="sm" classes={{ paperWidthSm: "wider-dialoge" }}>
					<div style={{ padding: "1em" }}>
						<div>
							<div className="row">
								<div className="col-md-12">
									Error: <div style={{ color: "red" }}>{" " + JSON.stringify(this.state.error["error"])} </div>
								</div>
							</div>
							<div className="row" style={{ paddingRight: "2em" }}>
								<button className="btn btn-jt-ops pull-right" onClick={() => { this.setState({ showErrorModal: false }) }}>
									OK
								</button>
							</div>
						</div>
					</div>
				</Dialog>
			</div>
		);
	}

	fetchConfig(bzId) {
		CreditLineApiHandler.fetchCutomerCreditDetails(bzId)
			.then(
				function (resp) {
					this.setState({
						creditLineStatusSet: resp.creditLineStatusSet,
						creditProducts: resp.creditProducts
					});
				}.bind(this)
			)
			.catch( (data) => {
				this.setState({
					error: data.error,
					showErrorModal: true,
				});
			});
		// CreditLineApiHandler.getCreditLineConfig()
		// 	.then(
		// 		function (resp) {
		// 			this.setState({
		// 				creditLineStatusSet: resp.creditLineStatusSet,
		// 				creditProducts: resp.creditProducts
		// 			});
		// 		}.bind(this)
		// 	)
		// 	.catch( (data) => {
		// 		this.setState({
		// 			error: data.error,
		// 			showErrorModal: true,
		// 		});
		// 	});
	}

	showAvailableDestinationDestinationProducts() {
		let options;
		if (this.state.dataToMerge) {
			options = this.state.dataToMerge.map((res, index) => {
				if (res.creditProductName !== this.state.dataFromMerge.creditProductName) {
					return <option key={index}>{res.creditProductName}</option>;
				}
				return null;
			});
		}
		return options;
	}

	showCircularLoading() {
		return <CircularProgress size={21} />;
	}

	handleMoveNowClick() {
		this.setState({ openModal: false, openModalConfirmation: true });
	}

	handleCloseConfirmation() {
		this.setState({ openModalConfirmation: false, destinationProductName: null });
	}

	mergeCreditLines(destinationData) {
		if (destinationData) {
			this.setState({
				loaderForMerging: true
			});
			var req = {
				bzId: destinationData.bzId,
				sourceProductName: this.state.dataFromMerge.creditProductName,
				destinationProductName: destinationData.creditProductName
			};
			CreditLineApiHandler.mergeCreditLines(req)
				.then(function (response) {
					this.componentDidMount();
					this.setState({
						loaderForMerging: false
					})
					this.handleCloseConfirmation();
				}.bind(this))
				.catch( (error) => {
					this.setState({
						error: error.error,
						showErrorModal: true,
					});
				})
				.finally(function () {
					this.setState({
						loaderForMerging: false
					})
				}.bind(this))
		}
	}

	handleMove() {
		var destdata;
		for (var i = 0; i < this.state.dataToMerge.length; i++) {
			if (this.state.dataToMerge[i].creditProductName === this.state.destinationProductName) {
				destdata = this.state.dataToMerge[i];
				break;
			}
		}
		this.mergeCreditLines(destdata);
	}

	handleMoveClick() {
		return (
			<div>
				<Dialog open={this.state.openModalConfirmation} onClose={this.handleCloseConfirmation} aria-labelledby="responsive-dialog-title" maxWidth="md" classes={{ paperWidthSm: "wider-dialoge" }}>
					<div>
						<div style={{ padding: "20px" }}>
							<div className="row">
								<div className="col-md-12">
									<div className="pull-right" onClick={this.handleCloseConfirmation} style={{ fontSize: "22px", cursor: "pointer" }}>
										<i className="fas fa-times" />
									</div>
								</div>
							</div>
							<div className="centralized">
								<div>Are you sure you want to merge</div>
								<div>
									<div className="bold inline"> {this.state.dataFromMerge.creditProductName} </div> with <div className="bold inline"> {this.state.destinationProductName} </div>
								</div>
								<div>
									for
									<div className="bold inline">
										{" " + this.state.dataFromMerge.bzId + " "} ({this.state.dataFromMerge.storeName}
										)?
									</div>
								</div>
								<div style={{ color: "red" }}>
									This action is irreversible.
								</div>
							</div>
							<div className="row">
								<div className="centralized" style={{ padding: "15px 0px 0px 0px" }}>
									<div onClick={this.handleMove} className="col-md-6">
										<div className="row">
											<div className="col-md-6">
												<button type="button" className="btn btn-jt-ops">Merge now</button>
											</div>
											<div className="col-md-6">
												<div className="inline">{this.state.loaderForMerging ? this.showCircularLoading() : null}</div>
											</div>
										</div>
									</div>
									<div className="col-md-6">
										<button onClick={this.handleCloseConfirmation} className="btn btn-jt-ops-inverted">
											Cancel
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</Dialog>
			</div>
		);
	}

	destinationProductNamePicker(event) {
		if (event.target.value === "Select Product Name")
			this.setState({
				destinationProductName: null
			});
		else
			this.setState({
				destinationProductName: event.target.value
			});
	}

	handleClickOpen = data => {
		this.setState({ dataFromMerge: data });
		this.handleSearchForDestinationProductName(data.bzId);
	};

	handleClose = () => {
		this.setState({ openModal: false });
	};

	handleSearch(selectedStatus, selectedProduct, from_dpd, to_dpd, equals, bzid, offsetVal) {
		var emptyString = "";
		this.setState({
			bzId: bzid,
			creditLineStatus: selectedStatus,
			productName: selectedProduct,
			fromDpd: from_dpd,
			toDpd: to_dpd,
			equalToDpd: equals,
			loading: true
		});
		this.offset = offsetVal;
		if (offsetVal === 0) {
			this.setState({ pageNumber: 1 });
		}
		var filterArray = {
			creditLineStatus: selectedStatus ? (selectedStatus === emptyString || selectedStatus === "Status" ? null : selectedStatus.trim()) : null,
			productName: selectedProduct ? (selectedProduct === emptyString || selectedProduct === "Product Name" ? null : selectedProduct.trim()) : null,
			dpdFilters: {
				fromDpd: from_dpd ? (from_dpd === emptyString ? null : from_dpd.trim()) : null,
				toDpd: to_dpd ? (to_dpd === emptyString ? null : to_dpd.trim()) : null,
				equalToDpd: equals ? (equals === emptyString ? null : equals.trim()) : null
			},
			bzId: bzid ? (bzid === emptyString ? null : bzid.trim()) : null
		};
		var request = {
			filters: filterArray,
			limit: this.limit,
			offset: this.offset
		};
		CreditLineApiHandler.fetchCutomerCreditDetails(bzid)
			.then(
				function (resp) {
					console.log(resp)
					this.setState({
						creditLines: resp
					});
				}.bind(this)
			)
			.catch( (error) => {
				this.setState({
					error: error.error,
					showErrorModal: true,
				});
			})
			.finally(
				function () {
					this.setState({
						loading: false
					});
				}.bind(this)
			);
		// CreditLineApiHandler.getCreditLines(request)
		// 	.then(
		// 		function (resp) {
		// 			console.log(resp)
		// 			this.setState({
		// 				creditLines: resp
		// 			});
		// 		}.bind(this)
		// 	)
		// 	.catch( (error) => {
		// 		this.setState({
		// 			error: error.error,
		// 			showErrorModal: true,
		// 		});
		// 	})
		// 	.finally(
		// 		function () {
		// 			this.setState({
		// 				loading: false
		// 			});
		// 		}.bind(this)
		// 	);
	}

	// update model - code - starts
	handleClickUpdateFromLineItems = (id, status) => {
		this.setState({
			renderModalForUpdate: true,
			creditLineIdForupdate: id,
			creditLineStatusForUpdate: status
		})
	}

	showModalForUpdate = () => {
		if (this.state.creditLineIdForupdate && this.state.creditLineStatusForUpdate){
			return (
				<UpdateModal id={this.state.creditLineIdForupdate} status={this.state.creditLineStatusForUpdate} handleClickUpdate={this.handleClickUpdate} handleCloseStatusModel={this.handleCloseStatusModel} creditLineStatusSet={this.state.creditLineStatusSet}/>
			);
		}
		else {
			return null;
		}
	}

	handleClickUpdate = (nachAccountId, creditLineStatus, statusChangeComments) => {
		this.setState({
			loaderForMerging: true
		});
		var request = {
			creditLineNaturalId: this.state.creditLineIdForupdate,
			nachAccountId: nachAccountId,
			creditLineStatus: creditLineStatus,
			statusChangeComments: statusChangeComments
		}
		CreditLineApiHandler.updateStatusOrNachAccountId(request)
			.then(() => {
				this.setState({
					nachAccountIdModalStatusUpdate: null,
					toStateModalStatusUpdate: null,
					selectedBzIdModalStatusUpdate: null,
					commentModalStatusUpdate: null
				});
				this.handleCloseStatusModel();
				var state = this.state;
				this.handleSearch(state.creditLineStatus, state.productName, state.fromDpd, state.toDpd, state.equalToDpd, state.bzId, this.offsetVal);
			})
			.catch((data) => {
				this.setState({
					error: data.error,
					showErrorModal: true,
				});
			})
			.finally(function () {
				this.setState({
					loaderForMerging: false
				});
			})
	}

	handleCloseStatusModel = () => {
		this.setState({
			renderModalForUpdate: false,
			creditLineIdForupdate: null,
			creditLineStatusForUpdate: null
		});
	}

	// update model - code - ends

	showModalContent() {
		return (
			<div className="row">
				<div className="col-md-12">
					<div className="">
						Merge <div className="bold inline">{this.state.dataFromMerge.creditProductName}</div> for{" "}
						<div className="bold inline">
							{this.state.dataFromMerge.bzId}({this.state.dataFromMerge.storeName})
						</div>{" "}
						with:
					</div>
					<div className="backgroundMoveTo centralized">
						Select destination product
						<div style={{ padding: "20px" }}>
							<select id="productType" onChange={this.destinationProductNamePicker.bind(this)} className="selectpicker1" value={this.state.destinationProductName}>
								<option> Select Product Name </option>
								{this.showAvailableDestinationDestinationProducts()}
							</select>
						</div>
					</div>
					<div className="centralized" style={{ padding: "15px 0px 0px 0px" }}>
						<button onClick={this.handleMoveNowClick} className="btn btn-jt-ops" disabled={this.state.destinationProductName === null ? true : false}>
							Merge now
						</button>
					</div>
				</div>
			</div>
		);
	}
	showErrorContent() {
		return (
			<div className="row" style={{ padding: "0px 15px" }}>
				<div className="col-md-12 backgroundMoveTo centralized" style={{ color: "red" }}>
					There is are no other Credit Products to merge with.
				</div>
			</div>
		);
	}

	handleMoveToModal() {
		let showModalContent = false;
		if (this.state.dataToMerge === null || this.state.dataToMerge.length === 1) {
			showModalContent = false;
		}
		else {
			showModalContent = true;
		}
		return (
			<div>
				<Dialog open={this.state.openModal} onClose={this.handleClose} aria-labelledby="responsive-dialog-title" maxWidth="md" classes={{ paperWidthSm: "wider-dialoge" }}>
					<div>
						<div style={{ padding: "15px" }}>
							<div className="row">
								<div className="col-md-12">
									<div className="pull-right" onClick={this.handleClose} style={{ fontSize: "22px", cursor: "pointer" }}>
										<i className="fas fa-times" />
									</div>
								</div>
							</div>
							{showModalContent ? this.showModalContent() : this.showErrorContent()}
						</div>
					</div>
				</Dialog>
			</div>
		);
	}

	handleSearchForDestinationProductName(bzid) {
		var emptyString = "";
		this.setState({
			showCircularLoading: true
		});
		var filterArray = {
			creditLineStatus: null,
			productName: null,
			dpdFilters: {
				fromDpd: null,
				toDpd: null,
				equalToDpd: null
			},
			bzId: bzid ? (bzid === emptyString ? null : bzid.trim()) : null
		};
		var request = {
			filters: filterArray,
			limit: this.limit,
			offset: this.offset
		};
		CreditLineApiHandler.getCreditLines(request)
			.then(
				function (resp) {
					this.setState({
						dataToMerge: resp,
						openModal: true
					});
				}.bind(this)
			)
			.catch( (error) => {
				this.setState({
					error: error.error,
					showErrorModal: true,
				});
			})
			.finally(
				function () {
					this.setState({
						showCircularLoading: false
					});
				}.bind(this)
			);
	}

	calculatePageNumber(fromMethod) {
		var offsetVal = this.offset;
		var limit = this.limit;
		if (fromMethod === "next") {
			offsetVal += limit;
		} else {
			offsetVal -= limit;
		}
		this.offset = offsetVal;
		this.setState({
			pageNumber: offsetVal / limit + 1
		});
		var state = this.state;
		this.handleSearch(state.creditLineStatus, state.productName, state.fromDpd, state.toDpd, state.equalToDpd, state.bzId, offsetVal);
	}

	showCreditLines() {
		var lines;
		if (this.state.creditLines) {
			// lines = this.state.creditLines.map((line, index) => {
			// 	return (
			// 		<div key={index}>
			// 			<CreditLineItem data={line} handleClickOpen={this.handleClickOpen} showCircularLoading={this.state.showCircularLoading} handleClickUpdateFromLineItems={this.handleClickUpdateFromLineItems} />
			// 		</div>
			// 	);
			// });
			lines = <CreditLineItem data={this.state.creditLines} handleClickOpen={this.handleClickOpen} showCircularLoading={this.state.showCircularLoading} handleClickUpdateFromLineItems={this.handleClickUpdateFromLineItems} />
		}
		return lines;
	}

	render() {
		return (
			<div>
				<div id="topFilter">
					<CreditLinesHeader creditLineStatusSet={this.state.creditLineStatusSet} creditProducts={this.state.creditProducts} handleSearch={this.handleSearch} />
				</div>
				<div id="creditLines" style={{ overflow: "scroll" }}>
					{this.state.loading ? this.showLoadingScreen() : this.showPage()}
					{/* {this.state.openModal ? this.handleMoveToModal() : null}
					{this.state.openModalConfirmation ? this.handleMoveClick() : null}
					{this.state.openModalForStatusChange ? this.handleChangeStatusModal() : null}
					{this.state.showErrorModal ? this.showErrorMessageModal() : null}
					{this.state.renderModalForUpdate? this.showModalForUpdate() : null} */}
				</div>
			</div>
		);
	}

	showPage() {
		return (
			<div>
				<div style={{ padding: "20px" }}>
					<IngestionBox />
				</div>
				<div style={{ padding: "0 20px 20px 20px" }}>{this.showCreditLines()}</div>
				{(this.state.creditLines && this.state.creditLines.length > 0) ? 
				<div>
				{this.pagenation()}
				</div>:null
				}
			</div>
		);
	}

	pagenation() {
		return (
			<div style={{ padding: "15px 0 40px 0", textAlign: "center" }}>
				<button
					type="button"
					className={this.state.pageNumber < 2 ? "btn btn-primary disabled" : "btn btn-primary active"}
					onClick={() => {
						this.calculatePageNumber("prev");
					}}
				>
					Previous page
				</button>
				<button className="btn btn-default" disabled="disabled" style={{ margin: "0 5px" }}>
					{this.state.pageNumber}
				</button>
				<button
					type="button"
					className={this.state.creditLines && this.state.creditLines.length < 50 ? "btn btn-primary disabled" : "btn btn-primary active"}
					onClick={() => {
						this.calculatePageNumber("next");
					}}
				>
					Next page
				</button>
			</div>
		);
	}

	showLoadingScreen() {
		return (
			<div className="no-jobs-to-assign">
				<div className="lds-hourglass" />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/screens/customerCreditDetails/components/CreditLines.js